import {
  SummaryList, TextInput,
} from 'nhsuk-react-components';
import React, {
  ChangeEvent, useEffect, useRef, useState,
} from 'react';

interface ListItemProps {
    value: string;
    isEditing: boolean;
    onEdit: () => void;
    onDelete: () => void;
    onSave: (newValue: string) => void;
    onCancel: () => void;
    isLastItem?: boolean;
}

function ListItem({
  value,
  isEditing,
  onEdit,
  onDelete,
  onSave,
  onCancel,
  isLastItem,
}: ListItemProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const [textValue, setTextValue] = useState(value);

  const handleSaveEdit = () => {
    onSave(textValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSave(textValue);
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };
  const rowClassName = !isLastItem ? undefined : 'nhsuk-summary-list__row--no-border';
  return (
    <SummaryList.Row className={rowClassName}>
      <SummaryList.Value>
        {isEditing ? (
          <TextInput
            data-testid={`${value}-input`}
            value={textValue}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setTextValue(e.target.value)}
            aria-label={`Edit item: ${value}`}
            ref={inputRef}
            onKeyDown={handleKeyDown}
          />
        ) : (
          <p className="text-wrap">{value}</p>
        )}
      </SummaryList.Value>
      <SummaryList.Action>
        {isEditing ? (
          <>
            <button
              type="button"
              className="nhsuk-back-link__link action-button"
              onClick={handleSaveEdit}
              aria-label={`Save changes for item: ${value}`}
            >
              Save
            </button>
            <button
              type="button"
              className="nhsuk-back-link__link action-button"
              onClick={onCancel}
              aria-label={`Cancel changes for item: ${value}`}
            >
              Cancel
            </button>
          </>
        ) : (
          <>

            <button
              type="button"
              className="nhsuk-back-link__link action-button"
              onClick={onEdit}
              aria-label={`Edit item: ${value}`}
            >
              Edit
            </button>
            <button
              type="button"
              className="nhsuk-back-link__link action-button delete-button"
              onClick={onDelete}
              aria-label={`Delete item: ${value}`}
            >
              Delete
            </button>
          </>
        )}
      </SummaryList.Action>
    </SummaryList.Row>
  );
}

export default ListItem;
